import React from 'react'
import { RenderFlagTrigger } from 'ui/src/components/layout/header/language-switch/render-flag-trigger'
import { useLanguageSwitch } from 'ui/src/hooks/use-language-switch'

export const LoginLangSelector = () => {
  const { handleOpen: openLanguageSwitchModal } = useLanguageSwitch()

  return (
    <div className='flex justify-end'>
      <button
        className='flex items-center gap-1 text-sm'
        onClick={openLanguageSwitchModal}
      >
        <RenderFlagTrigger labelSize='short' />
      </button>
    </div>
  )
}
